import React, { useState } from "react";
import { motion } from "framer-motion";






const Banner = ({ bannerData }) => {

  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);

  return (
    <motion.div




      onViewportEnter={() => setIsInView(true)}


      className="h-[50vh] relative overflow-hidden">
      <motion.img
        src={bannerData.img}
        className="w-full h-full object-cover object-center "

        onLoad={() => setIsLoaded(true)}


        initial={false}
        animate={isLoaded && isInView && isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 1.5 }}
        transition={{ duration: isInView ? 1 : 0, delay: isInView ? 2 : 0, ease: "easeInOut" }}
      />

      <motion.div

        onLoad={() => setIsLoaded(true)}


        initial={false}
        animate={isLoaded && isInView && isInView ? { opacity: 1, scale: 1, width: '100%' } : { opacity: 0, scale: 1.1, width: '0%' }}
        transition={{ duration: isInView ? 1 : 0, delay: isInView ? 0 : 0, ease: "easeInOut" }}

        className="h-full  bg-black opacity-65 mix-blend-soft-light absolute top-0 left-0 z-40"></motion.div>

      <motion.div

        initial={false}
        animate={isLoaded && isInView && isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -100 }}
        transition={{ duration: isInView ? 1 : 0, delay: isInView ? 1.5 : 0, ease: "easeInOut" }}

        className=" h-full w-full absolute z-50 flex items-center justify-center  top-0 left-0 text-35 text-white tracking-widest">
        {bannerData.title}
      </motion.div>



      {
        bannerData.logo &&
        <motion.div
          initial={false}
          animate={isLoaded && isInView && isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -100 }}
          transition={{ duration: isInView ? 1 : 0, delay: isInView ? 1.5 : 0, ease: "easeInOut" }}
          className=" h-full w-full absolute z-50 flex items-center justify-center  top-0 left-0 text-35 text-white tracking-widest">
          <img src={bannerData.logo} className="w-72" />
        </motion.div>

      }



    </motion.div>
  );
};

export default Banner;
